import { getEuroFormat } from '@/shared/helpers/formatters';
import { ASSETS_NAMES } from '@/shared/utils/constants';
import { AssetBalance } from '@/types/balances';
import { IonRow } from '@ionic/react';
import { capitalize } from 'lodash';
import { useTranslation } from 'react-i18next';
import styles from './AssetBalanceDetails.module.css';
import { useIsMobile } from '@/shared/hooks/devices';
import React from 'react';
import CryptoTitle from '@/shared/components/CryptoTitle/CryptoTitle';
import { getCryptoAmount } from '@/shared/helpers/crypto';
import { useGetMarketInfoQuery } from '@/features/marketInfo/marketInfoApi';
import Tooltip from '@/shared/components/Tooltip/Tooltip';

type Props = {
  assetBalance: AssetBalance | undefined;
};

const AssetBalanceDetails: React.FC<Props> = ({ assetBalance }) => {
  const { error: marketInfoError } = useGetMarketInfoQuery(undefined);

  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const assetId = assetBalance?.assetId;

  const available = Number(assetBalance?.available);
  const blocked = Number(assetBalance?.locked);
  const total = available + blocked;

  return assetBalance ? (
    <div className={styles.container}>
      {!isMobile && (
        <CryptoTitle assetId={assetId}>
          {ASSETS_NAMES[assetId || '']} {t('general.balance')}
        </CryptoTitle>
      )}

      <div className={styles.detailsContainer}>
        <IonRow class={'ion-justify-content-between'}>
          <span className={styles.title}>{t('general.total')}</span>
          <span className={styles.amountAvailable}>{getCryptoAmount(total, assetId)}</span>
        </IonRow>

        <IonRow class="ion-justify-content-between">
          <span className={styles.title}>{t('wallet.blocked_balance')}</span>
          <span className={styles.amountAvailable}>{getCryptoAmount(blocked, assetId)}</span>
        </IonRow>

        <IonRow class="ion-justify-content-between">
          <span className={styles.title}>{capitalize(t('general.available'))}</span>
          <span className={styles.amountAvailable}>{getCryptoAmount(available, assetId)}</span>
        </IonRow>

        {assetId === 'eur' || !assetId ? null : (
          <IonRow class={'ion-justify-content-between'}>
            <span className={styles.title}>{t('portfolio.availableEuro')}</span>
            {marketInfoError ? (
              <span>
                {t('market.info.not.available.info')}
                <Tooltip
                  iconSrc="assets/icons/information-circle-outline.svg"
                  id={assetId + 'BalanceDetails'}
                  showBackdrop={true}
                  triggerAction="hover"
                  content={t('market.info.not.available.detail.info')}
                />
              </span>
            ) : (
              <span className={styles.amountAvailable}>{`${getEuroFormat(Number(assetBalance?.euroValue))}`}</span>
            )}
          </IonRow>
        )}
      </div>
    </div>
  ) : (
    <span>No data available</span>
  );
};

export default AssetBalanceDetails;
